<template>
    <div class="jad-block-footer-nav">
        <div class="jad-block-footer-nav-content">
            <div class="jad-block-footer-nav-content-logo">
                <img
                    class="jad-block-footer-nav-content-logo-img"
                    src="//img10.360buyimg.com/img/jfs/t1/239423/22/23881/5739/6752d4e5F502b4d8d/98a5d7ae95f0303d.png">
                <div class="jad-block-footer-nav-content-logo-right">
                    Copyright © 2017 - 2022 京东JD.com 版权所有<br/>京ICP备11041704号-20 京ICP证070359号
                </div>
            </div>
            
            <div class="jad-block-footer-nav-list">
                <div
                    v-for="group in list"
                    :key="group.title"
                    class="jad-block-footer-nav-group"
                >
                    <p class="jad-block-footer-nav-group-title">
                        {{ group.title }}
                    </p>
                    <ul>
                        <template v-for="item in group.list">
                            <li
                                v-if="item.link"
                                :key="item.title"
                            >
                                <a
                                    target="_blank"
                                    :href="item.link">{{ item.title }}</a>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "FooterNav",
  data() {
    return {
      list: [
        {
          title: "友情链接",
          list: [
            {
              link: "https://jzt.jd.com/gw/index",
              title: "京准通"
            },
            {
              link: "https://agency.jd.com/gw/index?code=-300",
              title: "京营合作伙伴"
            },
            {
              link: "https://xue.jd.com/",
              title: "商家学习中心"
            }
          ]
        },
        {
          title: "快速链接",
          list: [
            {
              link: "https://sz.jd.com/sz/view/index/login.html?ReturnUrl=https%3A%2F%2Fsz.jd.com%2F",
              title: "京东商智"
            },
            {
              link: "https://4a.jd.com/datamill/common/goal.html",
              title: "京东数坊"
            },
            {
              link: "https://cdp.jdx.com/ca/growth-discovery",
              title: "京东天链"
            },
            {
              link: "https://survey.jd.com/",
              title: "京洞察"
            }
          ]
        },
        {
          title: "联系我们",
          list: [
            {
              link: "#",
              title: "售前咨询：13811274079"
            },
            {
              link: "#",
              title: "合作咨询：mktc@jd.com"
            },
            {
              link: "#",
              title: "服务时间：每周一至周五09:00~18:00"
            }
          ]
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.jad-block-footer-nav {
  background-color: #2a2a2a;
  width: 100%;
  color: #ffffffcc;

  .jad-block-footer-nav-content {
    display: flex;
    justify-content: space-between;
    width: 1180px;
    padding: 40px 0;
    margin: 0 auto;

    .jad-block-footer-nav-content-logo {
      display: inline-block;
    }

    .jad-block-footer-nav-content-logo-img {
      width: 260px;
    }

    .jad-block-footer-nav-content-logo-right {
      font-size: 14px;
      line-height: 20px;
      margin-top: 36px;
      font-weight: 400;
      color: #999;
    }

    .jad-block-footer-nav-list {
      display: flex;

      .jad-block-footer-nav-group {
        margin-left: 60px;
      }

      .jad-block-footer-nav-group:first-child {
        margin-left: 0;
      }

      .jad-block-footer-nav-group-title {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 15px;
      }

      .jad-block-footer-nav-group li {
        color: #ffffff80;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 10px;
        transition: color 0.3s;
      }

      .jad-block-footer-nav-group li a {
        color: #ffffff80;
      }
    }
  }
}
</style>